// frontend/src/utils/money.js
// Central, currency-aware money formatting — the foundation for multi-region
// support. Format ALL money through here so an account's currency drives the
// whole UI. Defaults to NGN (current market).

export const CURRENCIES = {
  NGN: { symbol: '₦', locale: 'en-NG' },
  USD: { symbol: '$', locale: 'en-US' },
};

export const DEFAULT_CURRENCY = 'NGN';

// The active account's currency. Set once on login via setActiveCurrency, so
// every formatMoney/formatNaira call reflects the user without threading the
// currency through every component.
let activeCurrency = DEFAULT_CURRENCY;

export const setActiveCurrency = (currency) => {
  activeCurrency = CURRENCIES[currency] ? currency : DEFAULT_CURRENCY;
};

export const getActiveCurrency = () => activeCurrency;

// formatMoney(1234.5) -> active currency; formatMoney(1234.5, 'USD') -> "$1,234.50"
export const formatMoney = (amount, currency) => {
  const cfg = CURRENCIES[currency || activeCurrency] || CURRENCIES[DEFAULT_CURRENCY];
  const formatted = Number(amount || 0).toLocaleString(cfg.locale, {
    minimumFractionDigits: 2,
    maximumFractionDigits: 2,
  });
  return `${cfg.symbol}${formatted}`;
};

// Legacy name kept so existing call sites work; now formats in the ACTIVE
// currency (not strictly naira). Prefer formatMoney in new code.
export const formatNaira = (amount) => formatMoney(amount);
